














import { Component, Vue } from 'vue-property-decorator';
import { BContainer, BCard, BCardBody } from 'bootstrap-vue';

@Component({
    components: {
        'b-container': BContainer,
        'b-card': BCard,
        'b-card-body': BCardBody
    }
})
export default class DataTable extends Vue {
}
